<template>
    <div class="wrap">
        <div v-if="tableData && tableData.length > 0" class="download-excel">
          <el-button type="primary" @click='downloadExcel' :disabled="downloadPadding ? true: false">{{downloadPadding ?'数据下载中...' : '下载数据导出Excel文件'}}</el-button>
        </div>
        <table class="form-list">
            <thead>
            <tr>
                <th>提交人</th>
                <th>提交时间</th>
                <th v-for="item in formdata.form_item_list">
                    {{item.name}}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in tableData">
                <td>
                    <span class="nickname">{{item.submit_user_name}}({{item.submit_user_id}})</span>
                </td>
                <td>{{formatDate(item.submit_time)}}</td>
                <td v-for="option in item.form_item_list">
                  {{getOptionValue(option.value,option.value_list) || '-'}}
                </td>
            </tr>
            </tbody>
        </table>
        <template v-if="tableData && tableData.length === 0">
            <table>
                <tbody>
                <tr>
                    <td style="color: #909399; height: 60px; border-left: 0px; border-right: 0px;">暂无数据</td>
                </tr>
                </tbody>
            </table>
        </template>
        <div v-if="tableData" class="pagination-wrapper">
            <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="requestData.count"
                    layout="total, prev, pager, next, jumper, sizes"
                    :total="totalNumber">
            </el-pagination>
        </div>
    </div>
</template>


<script>

  import Util from '@/js/util';

  export default {
    name: 'FormDataList',
    data() {
      return {
        tableData: null,
        totalNumber: null,
        currentPage: 1,
        requestData: {
          page: 0,
          count: 20,
        },
        formdata: {},
        downloadPadding: false,
      };
    },

    created() {
      var form_id = this.$route.params.form_id;
      this.formdata = lib.storage.get('formdata');
      if(this.formdata.form_item_list){
        try{
          this.formdata.form_item_list = JSON.parse(this.formdata.form_item_list);
        }catch(err){
        }
      }
      this.requestData.form_id = form_id;
      this.request();
    },

    methods: {
      downloadExcel(){
        if(this.downloadPadding){
          return;
        }
        this.downloadPadding = true;
        lib.tmsapi.get({
          api: 'api/test/excel/download',
          data: {
            form_id: this.requestData.form_id
          },
          success: (data) => {
            if(data && data.data && data.data.url){
              location.href = 'https://'+data.data.url;
            }
          },
          error: (data) => {
            if (data && data.msg) {
              this.$message.error(data.msg);
            }
          },
          complete: () => {
            this.downloadPadding = false;
          }
        })
      },
      request() {
        lib.tmsapi.get({
          api: 'api/test/form_data/list',
          data: this.requestData,
          success: (data) => {
            this.tableData = data.data;
            if(this.tableData && this.tableData.length && this.formdata.form_item_list && this.formdata.form_item_list.length){
              this.handleTableData();
            }
            this.totalNumber = data.total;
          },
          error: (data) => {
            if (data && data.msg) {
              this.$message.error(data.msg);
            }
          },
          complete: () => {

          }
        })
      },
      handleTableData(){
        this.tableData = this.tableData.map((item)=>{
          item.form_item_list = JSON.parse(item.form_item_list)
          return item;
        })
        this.tableData.forEach(tr => {
          if(tr.form_item_list.length != this.formdata.form_item_list.length){
            let tempTr = [];
            this.formdata.form_item_list.forEach((td, index)=>{
              let tempTd = {};
              if(tr && tr.form_item_list && tr.form_item_list.length){
                tr.form_item_list.forEach((tdv)=>{
                  if(tdv.name == td.name){
                    tempTd = tdv;
                  }
                })
              }
              if(tempTd.name){
                tempTr[index] = tempTd;
              }else{
                tempTr[index] = td;
              }
            })
            tr.form_item_list = tempTr;
          }
        });
      },

      toDelete(id, e) {
        this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.remove(id)
        }).catch(() => {
          // do sth
        });
      },

      toCheck(form) {
        this.$router.push({path: `/cms/form/${this.requestData.module_id}/data/${form.id}`});
      },

      toAdd() {
        this.$router.push({path: `/cms/form/${this.requestData.module_id}/add`});
      },

      remove(id, cb) {
        var that = this;
        lib.api.post({
          api: 'wdzg/b/cms/form/delete',
          data: {
            id: id
          },
          success: function (data) {
            that.$message.success('删除成功!');
            that.request();
          },
          error: function (data) {
            if (data && data.msg) {
              that.$message.error(data.msg);
            }
          },
          complete: function () {

          }
        })
      },

      getOptionValue(value, value_list) {
        if(value){
          return value;
        }else if(value_list){
          return value_list.join(',');
        }
      },

      formatDate(val) {
        return Util.formatDate(val*1)
      },

      handleCurrentChange(val) {
        this.requestData.page = val-1;
        this.request();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .download-excel{
    padding-bottom: 10px;
    text-align: right;
  }
    table > thead, table > tfoot {
        background: #efefef;
    }

    table > thead > tr > th, table > tfoot > tr > td {
        padding: 10px 0;
        border-bottom: 1px solid #e6ebf5;
        border-top: 1px solid #e6ebf5;
        text-align: center;
    }

    table > thead > tr > th:last-child, table > tfoot > tr > td:last-child {
        border-right: 1px solid #e6ebf5;
    }

    table > thead > tr > th:first-child, table > tfoot > tr > td:first-child {
        border-left: 1px solid #e6ebf5;
    }

    table > tbody > tr > td {
        text-align: center;
        padding: 10px 20px;
        border: 1px solid #e6ebf5;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
    }

    .avatar {
        display: inline-block;
        width: 50px;
        height: 50px;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 100%;
        border: solid 1px #fafafa;
        vertical-align: middle;
    }
    .wrap{
      background-color: #fff;
      padding: 20px;
    }
</style>
